(function (angular) {

    'use strict';

    angular.module('harriApp').controller('TalentScoutShareModal', TalentScoutShareModal);

    TalentScoutShareModal.$inject = ['$scope', 'modalData'];

    function TalentScoutShareModal($scope, modalData) {
        let self = this;
        self.url = modalData.url;
        self.userFullName = modalData.userFullName;

        self.hideModal = function () {
            $scope.$hide();
        };
    }
})(angular);
